var Firebase = require('firebase')
var GeoFire = require('geofire')
// explicit installation required in module environments
var config = {
  apiKey: 'AIzaSyC8yq1G_eUDEOW7e3ng2nCTlV90nZmeXSQ',
  authDomain: 'product-board.firebaseapp.com',
  databaseURL: 'https://product-board.firebaseio.com',
  storageBucket: 'product-board.appspot.com',
  messagingSenderId: '694238730184'
}
var firebaseInit = Firebase.initializeApp(config)

var firebaseApp = {
  auth: firebaseInit.auth(),
  db: firebaseInit.database(),
  storage: firebaseInit.storage(),
  geoFire: new GeoFire(firebaseInit.database().ref('/locations'))
}

module.exports = firebaseApp



// WEBPACK FOOTER //
// ./src/firebaseApp.js